
<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>培训中心</span><span>/</span><span>系统题库</span></div>
    <div class="disFlex between curse-search">
      <div>
      </div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.itype" placeholder="题型" clearable>
              <el-option key="1" label="单选" value="1"></el-option>
              <el-option key="2" label="多选" value="2"></el-option>
              <el-option key="3" label="判断" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline.parentid" placeholder="全部培训类别" clearable>
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                  :value="item.uniqueCode">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading" style="padding: 10px;background-color: #fff;">
      <el-table :data="tableData.rows" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column prop="cname" fixed width="450" label="题目">
        </el-table-column>
        <el-table-column prop="itype" label="题型" width="100" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.itype==1">单选</span>
            <span v-if="scope.row.itype==2">多选</span>
            <span v-if="scope.row.itype==3">判断</span>
          </template>
        </el-table-column>
        <el-table-column prop="parentname" label="所属分类" sortable>
        </el-table-column>
        <el-table-column prop="state" fixed="right" width="120" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看" placement="top">
              <el-button size="mini" circle type="success" icon="el-icon-view" @click="toDetail(scope.row.id,1)">
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="scope.row.isyr==0" class="item" effect="dark" content="引入" placement="top">
              <el-button @click="yinru(scope.row.id)" size="mini" circle type="warning" icon="el-icon-sold-out">
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import BaomingList from '../common/BaomingList';
  export default {
    props: ['collapse', 'wjSrc', 'zyjnList', 'zyzclist', 'currentUser'],
    data() {
      return {
        formInline: {
          parentid: '',
          page: 1,
          rows: 10,
          cid: '',
          state: '1',
          entitype: '1'
        },
        tableData: {
          rows: [],
          total: 0
        },
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        dialogVisible: false,
        selectUserIds: [],
        selectIdArr: [],
        selectRows: [],
        bmparams: {},
        loading: true
      }
    },
    methods: {
      getcurseList: function() {
        this.loading = true;
        this.$axios.get('/kt/ktQuestions/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      toAdd: function() {
        this.$router.push('/Company/Addprice');
      },
      toEdit: function(id) {
        this.$router.push('/Company/Addprice?id=' + id);
      },
      toDetail: function(id) {
        this.$router.push('/Company/Addprice?id=' + id + '&isck=1');
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      yinru: function(id) {
        var $this = this;
        this.$confirm('您确定要引入该题吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/kt/ktQuestions/updatequesCid.htm?ids=' + id).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.$message.success(data.message);
              this.getcurseList(1);
            } else {
              this.$message.error(data.message);
            }
          })
        }).catch(() => {});
      }
    },
    created: function() {
      this.$set(this.formInline, 'cid', '7e46061541f94daab2ebcef689ccf588')
      this.options[0].children = JSON.parse(localStorage.getItem('zyzcList'));
      this.options[1].children = JSON.parse(localStorage.getItem('zyjnList'));
    },
    components: {
      BaomingList
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1);
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-title span {
    width: 34px;
    height: 16px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
    color: #fff;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    margin-right: 2px;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;

  }

  .curseevery-bot img {
    margin-right: 4px;
  }

  .curseevery-top {
    position: relative;
  }

  .curseevery-top.ygq::after {
    content: "";
    content: '';
    display: block;
    width: 46px;
    height: 46px;
    background: url(../../assets/images/ygq.png) no-repeat;
    background-size: 46px 46px;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delVurse {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;
  }

  .delVurse span {
    cursor: pointer;
    font-size: 14px;
    color: #ff1515;
  }

  .curseevery-top:hover .delVurse {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/System.vue